import styled from "@emotion/styled";
import { IconButton, MenuItem } from "@mui/material";

export const ApplicationGuideWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 2rem;
`;

export const ApplicationGuideText = styled.span`
	color: #696969;
	font-size: 1rem;
	font-weight: 500;
	line-height: 1.75rem;
`;

export const ApplicationMenuButton = styled(IconButton)`
	width: 30px;
	height: 30px;
`;

export const ApplicationMenuItem = styled(MenuItem)`
	font-size: 12px;
	color: #545351;
	font-weight: bold;
`;

export const ApplicationNameWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export const ApplicationIcon = styled.div`
	width: 32px;
	height: 32px;
	margin-right: 12px;

	> img {
		width: 100%;
		height: 100%;
	}
`;

export const ApplicationName = styled.p`
	font-size: 16px;
	color: #545351;
	line-height: 16px;
	font-weight: bold;
`;

export const ModalTitle = styled.p`
	font-size: 14px;
	line-height: 28px;
	margin-bottom: 4px;
`;
